import Api from '@/api';
import * as types from '../mutation-types';

const state = {
  // 首頁廣告位
  index: [],
  products: [],
};

const getters = {
  // eslint-disable-next-line
  getAdsByPosition: (s) => (position) => {
    switch (position) {
      case '1':
        return s.index;
      default:
        return [];
    }
  },
};

const actions = {
  fetchAd({ commit }, position) {
    return Api.ad.get(position).then(({ data: response }) => {
      commit(types.RECEIVE_AD, { position, data: response.data });
    });
  },
};

/* eslint no-param-reassign: 0 */
const mutations = {
  [types.RECEIVE_AD](s, { position, data }) {
    switch (position) {
      case '1':
        s.index = data;
        break;
      default:
        break;
    }
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
